import { UserList } from "@/components/admin/UserList";

export default function UsersPage() {
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Gerenciamento de Usuários</h1>
        <p className="text-muted-foreground">
          Visualize, edite e gerencie todos os usuários do sistema.
        </p>
      </div>
      <UserList />
    </div>
  );
}
